import { SvgIcon } from './svg-icon';
import { ComponentSvgIconProps, SvgIconProps } from './svg-icon.d';
import { mergeProps } from 'solid-js';

const defaultProps: SvgIconProps = {
    viewBox: '0 0 20 20',
    fill: 'currentColor',
    defaultAriaLabel: 'Play Icon',
};

export const PlayIcon = (componentProps: ComponentSvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props}>
            <path
                d="M4.76401 14.9548V5.04557C4.76401 4.2375 5.64285 3.73601 6.33854 4.1471L14.7233 9.10172C15.4069 9.50566 15.4069 10.4947 14.7233 10.8987L6.33854 15.8533C5.64285 16.2644 4.76401 15.7629 4.76401 14.9548Z"
            />
        </SvgIcon>
    );
};
